import { LitElement, html } from 'lit-element';
import { binProfileIngredientParcel } from '~/parcels/bin-profile-ingredient/bin-profile-ingredient-parcel';
import { css } from '../js/utility/lit-entity';
import { ParcelLoader } from './parcel-loader';

class BinProfileIngredientParcelLoader extends ParcelLoader {
  static get styles() {
    return [css`
      .parcel-insertion-point {
        height: 100%;
      }
    `];
  }
}

window.customElements.define('bin-profile-ingredient-parcel-loader', BinProfileIngredientParcelLoader);

class BinProfileIngredient extends LitElement {
  static get properties() {
    return {
      className: { type: Object },
    };
  }

  static get styles() {
    return [css`
      .parcel-root {
        height: 100%;
      }
    `];
  }

  render() {
    const passThroughProperties = {
      href: this.href,
      className: this.className,
    };

    return html`
    <div class="parcel-root">
      <bin-profile-ingredient-parcel-loader
        .parcel=${binProfileIngredientParcel}
        .passThroughProperties=${passThroughProperties}
      ></bin-profile-ingredient-parcel-loader>
      </div>
    `;
  }
}

window.customElements.define('bin-profile-ingredient', BinProfileIngredient);
